
import React, {  useState, useRef } from 'react'
import { Grid, makeStyles } from "@material-ui/core";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Card from "@mui/material/Card";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { tableCellClasses } from '@mui/material/TableCell';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import axios from 'axios'
import CardContent from '@mui/material/CardContent';
import { CONFIG } from '../config'
import TableBody from '@mui/material/TableBody';
import EditIcon from '@mui/icons-material/Edit';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import { Info } from '@mui/icons-material';
import '../Css/Slider.css';
import useStyle from '../Css/MainCss';
import Delete from '@mui/icons-material/Delete';
import { Editor } from '@tinymce/tinymce-react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import parseHtml from 'html-react-parser';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));



const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const useStyles = makeStyles((theme) => ({
  right: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  root: {
    position: 'relative',
  },
  cardRiskManage: {
    width: '100%',
    border: '1px solid black'
  },
  tableTrStyle: {
    height: '19px !important'
  },
  mousePointer: {
    cursor: 'pointer'
  },
  stdMainCardHeader: {
    backgroundColor: '#4C7EE0 !important',
    fontSize: '13px !important',
    height: '50px',
    padding: '0px',
    marginTop: '-7px',
    color: 'white'
  },
  addrisktypebtn: {
    marginLeft: '0px !important',
    border: '1px solid #4C7EE0 !important',
    color: '#4C7EE0 !important',
    padding: '5px 10px !important',
    height: '40px !important',
  },

  btnBorderpurple: {
    border: '1px solid #9155FD !important',
    color: '#9155FD !important',
    padding: '5px 10px !important',
    height: '40px !important',
  },
  stdCard: {
    height: '100%',
    border: '1px solid black'
  },
  scrollableDivToStandard: {
    height: '350px',
    overflow: 'auto',
    width: '100%',
  },

}));


const SuperAdminAddEnquiryText = () => {
  const classe = useStyle();
  const classes = useStyles();

  React.useEffect(() => {
    getAllEnquiryTextData();
    setTimeout(() => {
    }, 1000);
  }, [])

  const [allEnquiryText, setAllEnquiryText] = useState([])

  function getAllEnquiryTextData() {
    axios(CONFIG.MAIN_URL + `/enquirytext/all`, {
      method: 'get',
      headers: {
        'Content-Type': 'text/plain',
      },
    })
      .then(function (response) {
        console.log("All Inquiry Text Returns");
        console.log(response.data);
        var arr = [];
        var count = 1;
        response.data.forEach((item) => {
            item["no"] = count;
            arr.push(item)
            count ++;
        })
        setAllEnquiryText(arr);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // console.log(selectedFile)
  const [saveBtnName, setSaveBtnName] = useState("Save");
  const [selectedEnquiryTextId, setSelectedEnquiryTextId] = useState('')
  const [enquiryTextName, setEnquiryTextName] = useState('')
  const [enquiryTextDescription, setEnquiryTextDescription] = useState('')

  const enquiryTextNameChange = (event) => {
    setEnquiryTextName(event.target.value);
  }

  const enquiryTextDescriptionChange = (event) => {
    setEnquiryTextDescription(event.target.value);
  }

  function editEnquiryTextData(id) {
    setSelectedEnquiryTextId(id);
    allEnquiryText.forEach((data) => {
      if (data.id === id) {
        setEnquiryTextName(data.name);
        setEnquiryTextDescription(data.description);
        setSaveBtnName("Update");
      }
    })
  }

  function deleteEnquiryTextData(id) {
    var arr = [];
    allEnquiryText.forEach((item) => {
      if (item.id === id) {
        const tmpName = item.name;
        var sendJson = JSON.stringify(item);
        console.log("+++++++++++++++++++sendJson To Delete++++++++++++++++++++");
        console.log(sendJson);
        var endPoint = '/enquirytext/delete';
        axios(CONFIG.MAIN_URL + endPoint, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          data: sendJson
        })
          .then(res => {

            alert('Successfully Deleted the Inquiry Text \" ' + tmpName + '\"');
            clearFuction();
            getAllEnquiryTextData();
          })
          .catch(function (error) {
            alert('Error Deleting the Inquiry Text \" ' + tmpName + '\"');
            console.log(error);
          });
      }
    })

  }

  function saveEnquiryTextFunction() {
    if (enquiryTextName === '') {
      alert("Please enter Inquiry Text Name");
      return;
    }
    if (enquiryTextDescription === '') {
      alert("Please enter Inquiry Text Description");
      return;
    }

    var obj = {};
    if (selectedEnquiryTextId != '') {
      obj["id"] = selectedEnquiryTextId;
    }
    obj["name"] = enquiryTextName;
    obj["description"] = enquiryTextDescription;

    var sendJson = JSON.stringify(obj);
    console.log("+++++++++++++++++++sendJson To Save++++++++++++++++++++");
    console.log(sendJson);
    var endPoint = '/enquirytext/save';
    if (selectedEnquiryTextId != '') {
      endPoint = '/enquirytext/update';
    }

    axios(CONFIG.MAIN_URL + endPoint, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: sendJson
    })
      .then(res => {

        if (selectedEnquiryTextId != '') {
          alert('Successfully Updated the Inquiry Text details');
        } else {
          alert('Successfully Save the Inquiry Text details');
        }
        clearFuction();
        getAllEnquiryTextData();
      })
      .catch(function (error) {
        alert('Error Updating the Inquiry Text');
        console.log(error);
      });
  }

  function clearFuction() {
    setSelectedEnquiryTextId('')
    setEnquiryTextName('')
    setEnquiryTextDescription('')
    setSaveBtnName("Save");
  }



  const previousCollectionTableRowData = (
    <TableBody>
      {allEnquiryText.map((item) => {
        return (
          <StyledTableRow key={item.id} className={classes.tableTrStyle}>
            <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} >
              <div style={{ whiteSpace: 'normal' }}>{item.no}</div>
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} >
              <div style={{ whiteSpace: 'normal' }}>{item.name}</div>
            </StyledTableCell>
            <StyledTableCell component="th" scope="row" className={classes.tableTrStyle} >
              <div style={{ whiteSpace: 'normal' }}>{item.description}</div>
            </StyledTableCell>
            <StyledTableCell
              align="right"
              className={classes.tableTrStyle}
            >
              <EditIcon
                className={classes.mousePointer}
                onClick={() => { editEnquiryTextData(item.id) }}
              />
            </StyledTableCell>
            <StyledTableCell
              align="right"
              className={classes.tableTrStyle}
            >
              <Delete
                className={classes.mousePointer}
                onClick={() => { deleteEnquiryTextData(item.id) }}
              />
            </StyledTableCell>
          </StyledTableRow>
        )
      })}
    </TableBody>
  )




  return (
    <>
      <div>
        <Grid >
          <Grid container spacing={2}>
            <>
              <Grid item xs={12} >
                <Card className={classes.cardRiskManage} >
                  <CardContent>
                    <Card >
                      <CardHeader
                        avatar={
                          <Avatar sx={{ bgcolor: '#69676e', width: '25px', height: '25px' }}>
                            <Info />
                          </Avatar>
                        }
                        className={classe.commonMainTableHead}
                        title={'Save / Edit Inquiry Text'}
                      />
                      <CardContent>
                        <Grid container spacing={2}>
                          <Grid item xs={3}>
                            <Box
                              component="form"
                              sx={{
                                '& .MuiTextField-root': { mt: 1, width: '100%' },
                              }}
                              noValidate
                              autoComplete="off"
                            >
                              <div>
                                <TextField
                                  id="title"
                                  label="Inquiry Text Name"
                                  multiline
                                  maxRows={2}
                                  name='title'
                                  required
                                  value={enquiryTextName}
                                  onChange={enquiryTextNameChange}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item xs={9}>
                            <Box
                              component="form"
                              sx={{
                                '& .MuiTextField-root': { mt: 1, width: '100%' },
                              }}
                              noValidate
                              autoComplete="off"
                            >
                              <div>
                                <TextField
                                  id="title"
                                  label="Inquiry Text Description"
                                  multiline
                                  maxRows={4}
                                  name='title'
                                  required
                                  value={enquiryTextDescription}
                                  onChange={enquiryTextDescriptionChange}
                                />
                              </div>
                            </Box>
                          </Grid>

                          <Grid item xs={12} style={{ textAlign: 'right' }}>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              style={{ marginTop: '10px', height: '46px' }}
                              onClick={() => {
                                saveEnquiryTextFunction();
                              }}
                            >
                              {saveBtnName}
                            </Button>&nbsp;&nbsp;
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              style={{ marginTop: '10px', height: '46px' }}
                              onClick={() => {
                                clearFuction()
                              }}
                            >
                              Clear
                            </Button>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </CardContent>
                </Card>
              </Grid>

                  <Grid item xs={12}>
                    <Card className={classes.stdCard}>
                      <CardHeader
                        avatar={
                          <Avatar sx={{ bgcolor: '#69676e', width: '25px', height: '25px' }}>
                            <Info />
                          </Avatar>
                        }
                        className={classes.stdMainCardHeader}
                        title="Inquiry Text Created"
                      />
                      <CardContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <div className={classes.scrollableDivToStandard}>
                              <TableContainer>
                                <Table aria-label="customized table">
                                  <TableHead className={classe.commonSecondaryTableHead}>
                                    <TableRow>
                                        <StyledTableCell className={classe.commonTableThStyle} style={{ width: '7%' }}>No</StyledTableCell>
                                        <StyledTableCell className={classe.commonTableThStyle} style={{ width: '20%' }}>Inquiry Text Name</StyledTableCell>
                                      <StyledTableCell className={classe.commonTableThStyle} style={{ width: '50%' }}>Inquiry Text Name</StyledTableCell>
                                      <StyledTableCell align="right" className={classe.commonTableThStyle} style={{ width: '10%' }}>Edit</StyledTableCell>
                                      <StyledTableCell align="right" className={classe.commonTableThStyle} style={{ width: '13%' }}>Delete</StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  {previousCollectionTableRowData}
                                </Table>
                              </TableContainer>
                            </div>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>

            </>
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default SuperAdminAddEnquiryText